module.exports = __webpack_public_path__ + "media/images/memes/happy-dance-e5e5f9c5ae071f97cf310ef83c1cd06c.gif";